<template>
  <v-container class="content">
    <!--loading screen when add video request is being handled-->
    <LoadingScreen :loading="loading" />

    <!-- Nav Header -->
    <div class="nav" @click="goBack">
      <v-icon size="12px" color="#00457C">arrow_back_ios</v-icon>Back
    </div>
    <div class="header text-left">Edit Announcement</div>

    <!-- Image Upload -->
    <v-row class="photo-label">
      <v-col cols="3">
        <label for="cover-photo">Cover Photo</label>
      </v-col>
    </v-row>
    <v-row class="photo-picker">
      <v-col cols="12">
        <input
          style="background-color: #ececec; color: grey"
          disabled
          id="cover-photo"
          type="text"
          v-model="imgUrl"
        />
      </v-col>
    </v-row>

    <!-- Start and End Dates -->
    <v-row class="date-labels">
      <v-col cols="3">
        <label for="startDate">Start Date</label>
      </v-col>
      <v-col cols="3">
        <label>{{ startDate }}</label>
      </v-col>
      <v-col cols="6">
        <input type="datetime-local" id="startDate" v-model="startDate" />
        <div class="error-msg" v-show="$v.startDate.$invalid">
          Start date has to be at least one day from today.
        </div>
      </v-col>
    </v-row>
    <v-row class="date-pickers">
      <v-col cols="3">
        <label for="endDate">End Date</label>
      </v-col>
      <v-col cols="3">
        <label>{{ endDate }}</label>
      </v-col>
      <v-col cols="6">
        <input type="datetime-local" id="endDate" v-model="endDate" />
        <div class="error-msg" v-show="$v.endDate.$invalid">
          End date has to be at least one day from start date.
        </div>
      </v-col>
    </v-row>

    <!-- Title -->
    <v-row>
      <v-col cols="12">
        <label for="ann-title">Notification Title</label>
        <input
          id="ann-title"
          type="text"
          v-model="notif_title"
          @input="$v.notif_title.$touch()"
        />
        <div
          class="error-msg"
          v-show="$v.notif_title.$invalid && $v.notif_title.$dirty"
        >
          This is a required field.
        </div>
        <br />
      </v-col>
    </v-row>

    <!-- Content -->
    <v-row>
      <v-col cols="12">
        <label for="ann-content">Notification Content</label>
        <textarea
          id="ann-content"
          v-model="notif_content"
          @input="$v.notif_content.$touch()"
        ></textarea>
        <div
          class="error-msg"
          v-show="$v.notif_content.$invalid && $v.notif_content.$dirty"
        >
          This is a required field.
        </div>
      </v-col>
    </v-row>

    <!-- Topic -->
    <v-row>
      <v-col cols="4" md="3">
        <label>Inbox Topic</label>
        <select v-model="selectedTopic">
          <option></option>
          <option :key="index" v-for="(topic, index) in allTopics">
            {{ topic.topic }}
          </option>
        </select>
      </v-col>
    </v-row>

    <!-- Title -->
    <v-row>
      <v-col cols="12">
        <label for="ann-title">Inbox Title</label>
        <input id="ann-title" type="text" v-model="title" />
        <div class="error-msg" v-show="$v.title.$invalid">
          This is a required field.
        </div>
        <br />
      </v-col>
    </v-row>

    <!-- Content -->
    <v-row>
      <v-col cols="12">
        <label for="ann-content">Content</label>
        <quill-editor
          id="ann-content"
          :content="content"
          @change="onEditorChange($event)"
        />
        <!-- <textarea id="ann-content" v-model="content"></textarea> -->
        <div class="error-msg" v-show="$v.content.$invalid">
          This is a required field.
        </div>
      </v-col>
    </v-row>

    <!-- Button Configurations -->
    <v-row>
      <v-col cols="4" md="3">
        <label for="ann-btn-title">Button Title</label>
        <input id="ann-btn-title" type="text" v-model="btnTitle" />
      </v-col>
      <v-col v-if="redirectUrl === ''" cols="4" md="3">
        <label for="ann-btn-url">Button Link</label>
        <select v-model="btnLink">
          <option></option>
          <option>Home</option>
          <option>Points</option>
          <option>Profile</option>
          <option>Shop</option>
          <option>Stores</option>
          <option>Instalment Summary</option>
          <option>Ticket Summary</option>
        </select>
      </v-col>
      <v-col v-if="btnLink === ''" cols="4" md="3">
        <label for="ann-btn-url">Button URL</label>
        <input id="ann-btn-url" type="text" v-model="redirectUrl" />
        <!-- <div class="error-msg" v-show="$v.redirectUrl.$invalid">Please enter a URL in the following format: http://www.example.com/.</div> -->
      </v-col>
    </v-row>

    <!-- Push notification checkbox -->
    <v-row>
      <v-col cols="12">
        <div style="display: flex; align-items: start">
          <label
            for="checkbox-notif"
            style="padding-right: 10px; line-height: 100%"
            >Broadcast Announcement</label
          >
          <input type="checkbox" id="checkbox-notif" v-model="sendNotif" />
        </div>
      </v-col>
    </v-row>

    <!-- Form Submit Button -->
    <v-row>
      <v-col cols="4" md="3">
        <v-btn color="#00457C" :disabled="$v.$invalid" @click="updateAnnForm"
          >Update</v-btn
        >
      </v-col>
    </v-row>

    <v-row v-if="success">
      <v-col cols="12">
        <v-alert type="success">Announcement updated successfully.</v-alert>
      </v-col>
    </v-row>
    <v-row v-if="error">
      <v-col cols="12">
        <v-alert type="error">Error occurred. Please try again.</v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Axios from "axios";
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import LoadingScreen from "./commons/LoadingScreen";

//form validation: check if end date falls after start date
let checkEndDate = (value, vm) => {
  let startDate = new Date(vm.startDate).getTime();
  let input = new Date(value).getTime();

  if (input > startDate) {
    return true;
  } else {
    return false;
  }
};

let checkTopic = (value, vm) => {
  // return true
  if (vm.selectedTopic == "") {
    return false;
  } else {
    return true;
  }
};

//sets btn link as valid if btn url is not selected and vice versa
// let checkLink = (value, vm) => {

//   if (vm.redirectUrl === "") {
//     if (vm.btnLink !== "") {
//       return true
//     }
//     else {
//       return false
//     }
//   }

//   if (vm.btnLink === "") {
//   if (vm.redirectUrl !== "") {
//     return true
//   }
//   else {
//     return false
//   }
// }

//   else {
//     return false
//   }

// }

export default {
  components: {
    LoadingScreen,
  },
  mounted() {
    // Fetch all topics
    Axios.get(process.env.VUE_APP_HOST_SERVER + "/api/topics/get_all")
      .then(({ data }) => {
        console.log("Successfully retrieved all topics");
        this.allTopics = data;
      })
      .catch((err) => console.log(err));

    // Fetch current announcement
    Axios.get(
      process.env.VUE_APP_HOST_SERVER + `/api/announcements/get/${this.itemId}`
    )
      .then((res) => {
        this.notif_title = res.data.notif_title;
        this.notif_content = res.data.notif_content;
        this.title = res.data.title;
        this.content = res.data.content;
        this.startDate = moment(res.data.startDate);
        this.endDate = moment(res.data.endDate);
        this.btnTitle = res.data.btnTitle;
        this.btnLink = res.data.btnLink;
        this.redirectUrl = res.data.redirectUrl;
        this.imgUrl = res.data.imgUrl;
        this.selectedTopic = res.data.topic;
      })
      .catch((err) => console.log(err));
  },
  data() {
    return {
      selectedTopic: "",
      allTopics: [],
      itemId: this.$route.params.itemId,
      notif_title: null,
      notif_content: null,
      title: null,
      content: null,
      startDate: null,
      endDate: null,
      btnTitle: null,
      btnLink: null,
      redirectUrl: null,
      imgUrl: null,
      sendNotif: true,
      loading: false,
      success: false,
      error: false,
    };
  },

  validations: {
    topic: {
      checkTopic,
    },

    notif_title: {
      required,
    },

    notif_content: {
      required,
    },

    title: {
      required,
    },

    content: {
      required,
    },

    startDate: {
      required,
    },

    endDate: {
      required,
      checkEndDate,
    },
  },

  methods: {
    goBack() {
      this.$router.push({ name: "Announcements" }).catch(() => {});
    },
    // TODO: validate redirect url to have http://
    updateAnnForm() {
      this.loading = true; //enable loading screen once user clicks submit
      const startDateTime = this.startDate;
      const endDateTime = this.endDate;

      const updatedAnnDetails = {
        notif_title: this.notif_title,
        notif_content: this.notif_content,
        title: this.title,
        content: this.content,
        startDate: new Date(startDateTime),
        endDate: new Date(endDateTime),
        btnTitle: this.btnTitle,
        btnLink: this.btnLink,
        redirectUrl: this.redirectUrl,
        imgUrl: this.imgUrl,
        topic: this.selectedTopic,
      };
      // Update Mongodb
      Axios.post(
        process.env.VUE_APP_HOST_SERVER +
          `/api/announcements/edit/${this.itemId}`,
        updatedAnnDetails
      )
        .then((res) => {
          // Send push notification
          if (this.sendNotif == true) {
            Axios.post(
              process.env.VUE_APP_HOST_SERVER +
                "/api/notifications/send_notif/topic",
              {
                notif_title: this.notif_title,
                notif_content: this.notif_content,
                title: this.title,
                bodyMessage: this.content,
                topic: this.selectedTopic,
                startDate: this.startDate,
                endDate: this.endDate,
                objectId: res.data._id,
              }
            );
          }

          this.loading = false; //disable loading screen once request is handled
          this.success = true; //show success message
          this.error = false;
          console.log("Successfully updated announcement ", updatedAnnDetails);
        })
        .catch((err) => {
          console.log(err);
          this.error = true;
        });
    },
    onEditorChange({ quill, html, text }) {
      console.log("editor change!", quill, html, text);
      this.content = html;
    },
  },
};
</script>

<style scoped>
.content {
  box-shadow: 0px 1px 20px rgba(163, 163, 163, 0.25);
  border: 1px solid #eeeeee;
  padding: 25px;
  text-align: initial;
}

.content .row {
  padding-bottom: 18px;
}

.content .row:nth-last-child(1) {
  padding-bottom: 0;
}

.content .nav {
  color: #00457c;
  font-weight: bold;
  margin-bottom: 40px;
  font-size: 16px;
  cursor: pointer;
}

.content .header {
  font-size: 26px;
  margin-bottom: 20px;
  font-weight: normal;
}

.content button {
  width: 100%;
  font-size: 14px;
  font-weight: normal;
  color: white;
  text-transform: none;
  letter-spacing: normal;
}

label {
  font-size: 14px;
  color: #6f6f6f;
  margin-bottom: 10px;
  display: block;
}

.content .date-labels,
.content .photo-label {
  padding-bottom: 0;
}

.content .date-labels > div,
.content .photo-label > div {
  padding-bottom: 0;
}

.content .date-pickers > div,
.content .photo-picker > div {
  padding-top: 0;
}

label#browse-btn {
  display: inline-block;
  background: #ffffff;
  box-shadow: 0px 1px 5px rgba(120, 120, 120, 0.25);
  border-radius: 5px;
  color: #9b9b9b;
  padding: 10px;
  margin-bottom: 0;
}

input[type="text"],
input[type="number"],
input[type="date"],
textarea,
select {
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  width: 100%;
  font-size: 14px;
}

.error-msg {
  font-size: 10px;
  color: #ea6254;
  margin-top: 5px;
}
</style>
